<template>
    <div class="fashion-filter-wrapper">
        <h3
                class="filters-header"
                v-on:click="headerClick"
                :class="{'header-active': status, 'has-items-selected': currentFilters.length > 0}"
        >{{filterLabels[title]}} <span class="d-inline-block d-lg-none">
                        <svg width="20" height="20" class="close">
                            <g>
                                <line x1="0" y1="10" x2="20" y2="10" stroke="#fff"/>
                            </g>
                        </svg>
                        <svg width="20" height="20" class="open">
                            <g>
                                <line x1="10" y1="0" x2="10" y2="20" stroke="#fff"/>
                                <line x1="0" y1="10" x2="20" y2="10" stroke="#fff"/>
                            </g>
                        </svg>
                    </span></h3>
        <div :class="'filters-list ' + (status ? 'active' : '') + (name === 'colour' ? ' filters-list-colors': '')">
            <ul v-if="terms" :class="{'has-terms-selected': currentFilters.length > 0}">
                <li
                        v-for="(filterItem, index) in terms"
                        :key="index"
                        v-on:click="filter(name, filterItem.term, filterItem.uri)"
                        v-if="filterItem.term"
                        :class="className(name, filterItem.term)"
                        :title="name === 'colour' ? filterItem.term : ''"
                        :id="name + generateId(filterItem)"
                >{{name !== 'colour' ? filterItem.term + ' (' + filterItem.count + ')' : ''}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {EventBus} from './event-bus'
import VueScrollTo from 'vue-scrollto'

const hashCode = function (text) {
  let hash = 0
  let i
  let chr
  if (text.length === 0) return hash
  for (i = 0; i < text.length; i++) {
    chr = text.charCodeAt(i)
    hash = ((hash << 5) - hash) + chr
    hash |= 0
  }
  return hash
}

export default {
  name: 'FashionFilter',
  props: [
    'name',
    'title',
    'terms',
    'setFilter',
    'activeFilters',
    'filterLabels',
    'searchTerm',
    'currentActiveFilter',
    'setCurrentActiveFilter'
  ],
  data () {
    return {
      keysPressed: null,
      timer: null,
      cancelScroll: null
    }
  },
  computed: {
    currentFilters: function () {
      let vm = this
      return vm.activeFilters.filter(e => e.type === vm.name)
    },
    status: function () {
      return this.currentActiveFilter === this.name
    }
  },
  beforeDestroy () {
    let vm = this
    vm.keysPressed = null
  },
  methods: {
    generateId (term) {
      const code = term && (term.uri || term.term)
      return term && hashCode(code)
    },
    headerClick () {
      let vm = this
      if (vm.currentActiveFilter && vm.currentActiveFilter === vm.name) {
        EventBus.$off('letterKeypress')
        vm.keysPressed = null
        vm.setCurrentActiveFilter(null)
      } else {
        vm.setCurrentActiveFilter(vm.name)
        EventBus.$on('letterKeypress', e => {
          vm.keysPressed = (vm.keysPressed !== null ? vm.keysPressed : '') + e
          clearTimeout(vm.timer)

          if (this.currentActiveFilter === vm.name) {
            const search = vm.terms.filter(term => {
              return term.term.toLowerCase().indexOf(vm.keysPressed) === 0
            })

            const component = search && search[0]
            if (component) {
              if (vm.cancelScroll) {
                vm.cancelScroll()
              }
              vm.cancelScroll = VueScrollTo.scrollTo(
                '#' + vm.name + vm.generateId(component),
                400,
                {
                  container: '.filters-list.active'
                }
              )
            }
          }
          vm.timer = setTimeout(() => {
            vm.keysPressed = null
          }, 1000)
        })
      }
    },
    filter (name, term, uri) {
      this.setCurrentActiveFilter(null)
      this.setFilter(name, term, uri)
    },
    className (name, term) {
      const out = []

      if (this.currentFilters.find(e => e.term === term)) {
        out.push('active')
      }

      if (name === 'colour') {
        out.push('color-item color-item-' + term)
      }

      return out
    }
  }
}
</script>

<style lang="scss" scoped>
    @import "_FashionFilter.scss";
</style>



// WEBPACK FOOTER //
// src/components/FashionFilter.vue